function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-reload",
    style: {
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s",
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(256.753 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 15A35 35 0 1 0 74.787 25.213",
    fill: "none",
    "ng-attr-stroke": "{{config.color}}",
    "ng-attr-stroke-width": "{{config.width}}",
    stroke: "#000",
    strokeWidth: 12,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "ng-attr-d": "{{config.darrow}}",
    "ng-attr-fill": "{{config.color}}",
    d: "M49 3L49 27L61 15L49 3",
    fill: "#000000",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.e118eea0d907e7156cf4bbc512ecae1c.svg";
export { ForwardRef as ReactComponent };